export default {
    site: {
        common: {
            hello: "Hola",
            thankYou: "Gracias",
            forMoreInfo: "para más información",
            hoverOverColumnHeaders: "Pasa el ratón por encima de las columnas para más información.",
            username: "usuario",
            score: "Puntuación",
            points: "Puntos",
            pointsAbbreviation: "pts",
            chapter: "Capítulo",
            tier: "Nivel",
            t1: "N1",
            t2: "N2",
            t3: "N3",
            collectionsPerDay: "Recolección por día",
            relicBoostPercent: "% de Bonificación de las Reliquias",
            mountainHallPercentShort: "% Caverna", // used in table heading keep it short.
            updated: "actualizado",
            lastUpdated: "Última actualización",
            created: "creado",
            role: "rol",
            Fellow: 'Hermano',
            Ambassador: 'Embajador',
            Mage: 'Mago',
            Archmage: 'Archimago',
            saveChanges: "Guardar Cambios",
            copy: "Copiar",
            close: "Cerrar",
            cancel: "Cancelar",
            action: "Acción",
            date: "Fecha",
            Left: "Abandonado",
            Joined: "Unido",
            human: "Humano",
            elf: "Elfo",
            search: "Buscar",
            enter: "Introduce",
            yes: "Si",
            no: "No",
            tournament: "Torneo",
            tournaments: "Torneos",
            fellowship: "Hermandad",
            player: "Jugador",
            member: "Miembro",
            history: "History",
            tournamentHistory:  "Historial de Torneo",
            scoreHistory: "Historial de Puntuación",
            server: "Servidor",
            lastWeekGain: "Ganancias última semana",
            comingSoon: "Muy pronto",
            chest: "cofre",
            yourServer: "Tu servidor",
            allServers: "Todos los servidores",
            boosts: "Bonificaciones",
            marble: "mármol",
            steel: "acero",
            planks: "tablones",
            crystal: "cristal",
            scrolls: "pergaminos",
            silk: "seda",
            elixir: "elixir",
            magic_dust: "polvo mágico",
            gems: "gemas",
            sentient: "sensitivos",
            goods: "productos",
            average: "average",
            expansions: 'Expansiones', // 5x5 grids
            cultureBoostMinimum: 'Bonificación Cultural Min',
            cultureBoostCalculated: 'Bonificación Cultural Calculada',
            neighborlyHelp: 'Ayuda Vecinal',
            neighborlyHelpAbbreviation: 'A.V.'
        },
        // HIGH PRIORITY
        nav: {
            home: "Inicio",
            players: "Jugadores",
            fellowships: "Hermandades",
            tournaments: "Torneos",
            contact: "Contactar",
            donate: "Donar",
            faq: "FAQ",
            news: "Noticias",
            privacyPolicy: "Política de Privacidad",
            me: "Yo",
            myFellowship: "Mi Hermandad",

            // NOTE USED AT THE MOMENT
            globalStats: "Estadísticas Globales",
            articles: "Artículos",
            fellowshipAdventure: "Aventuras de la Hermandad",
            recruit: "Reclutar",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Ver esta Ciudad en ElvenArchitect"
            ,obtainingLink: "Obtener Enlace"
            ,successMessage: "¡Perfecto! Haz Click en el siguiente enlace para abrir Architect"
            ,ageOfLink: "El siguiente link mostrará la ciudad tal y como está: "
            ,clickToGetCurrentCity: "<-- Haz Click para conseguir la ciudad actual",
        },
        // High Priority
        playerSelection: {
            headline: "Ver el sitio como",
            description: "Esto actualizará diferentes partes de la página al estar customizada para el usuario. Ejemplos: mi hermandad, mi usuario, torneos, y páginas de la clasificación",
            youAreViewing: `Estás viendo la página como {username} en {serverName}.`,
            changeUser: "Cambiar Jugador",
            enterYourUsernameToGetStarted: "Introduce tu Nick de Elvenar para empezar",
            thisIsNotASignup:"Esto no es un proceso de registro. Al entrar el nombre de usuario, simplemente customizamos la página adecuadamente. Al haber decenas de servidores en Elvenar, mostraremos la clasificación para tu servidor. Además, tu hermandad y usuario estarán disponibles."
        },
        searchBoxes: {
            enterFellowshipName: 'Introduce el Nombre de la Hermandad',
            instructions: "Escribe el nombre y selecciona uno.",
            noFellowship: "Sin Hermandad",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "days ago", // In Spanish should be "Hace {day parameter} días
            minsAgo: "mins ago",
            hoursAgo: "hrs ago",
            justNow: "just now",
            never: "Never",
        },
        home: {
            welcome: "Bienvenido a Elven Stats!",
            youAreViewing: "Estás viendo la página como {username} en {serverName}",
            youCanChange: "Puedes cambiar el nombre de usuario haciendo click en el avatar en la parte superior derecho o <router-link to='/contact'>visitando esta página</router-link>",
            features: {
                headline: "Características",
                fellowshipAdministration: {
                    headline: "Administración de la Hermandad <strong>MÁS FÁCIL QUE NUNCA</strong>",
                    bullet1: "Seguimiento automático de productos bonificados para balancear tu hermandad",
                    bullet2: "Generación y seguimiento automático de informes semanales que incluyen puntos, participación de torneos, crecimiento mensual, reconomimientos, y récords personales de crecimiento",
                    bullet3: "Ayuda a tus hermanos a identificar producciones no balanceadas o ratios de niveles incorrectos",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Integración</strong> con ElvenArchitect",
                    description: "¡Carga tu ciudad tal y como está en ElvenArchitect en segundos! Usa esta herramienta para planificar tu siguiente gran reorganización y encontrar espacio que pensabas que no tenías. ¡ Busca el logo de ElvenArchitect en las páginas de jugadores."
                },
                advancedRankingLists: {
                    headline: "<strong>Listas de Clasificación</strong> avanzadas",
                    bullet1: "Listas de Clasificación por areas desbloqueadas (para compararte con gente al mismo nivel)",
                    bullet2: "Mira las bonificaciones, el número de capítulo y mucho más en las listas de Jugador.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Seguimiento</strong> de Torneos de la Hermandad",
                    description: "Observa como va tu hermandad contra otras. Reta a otras hermandades para una competicion amistosa!",
                },
                matchMaking: {
                    headline: "<strong>Emparejamiento</strong>",
                    description: "ElvenStats sigue los ratios de los productos bonificados de las hermandades. Con esta información, las hermandades pueden reclutar los candidatos adecuados para balancear sus recursos. Los jugadores pueden encontrar hermandades que REALMENTE NECESITAN sus productos bonificados. ¡Reduciendo el tiempo y los rechazos!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Clasificación",
                points: "Puntos",
                medianUserScore: "Media de<strong>puntuación de usuario</strong>",
                memberCount: "<strong>Contador</strong> de Miembros",
            },
            barCharts: {
                clickSlice: "Haz Click para más detalles (por miembro)",
                tier1: "Nivel 1",
                tier2: "Nivel 2",
                tier3: "Nivel 3",
                drillDown: "Vovler a {0}"
            },
            idealCandidate: {
                heading: "Candidato Ideal",
                description: "Rondaría una puntuación de {medianScore} y tendría una o varias de las siguientes bonificaciones: {boosts}",
                note: "Algunas combinaciones de bonificaciones no son posibles. Echa un ojo a {0}"
            },
            memberGoodsTable: {
                heading: "Miembros de Producción de Productos",
                description: `Esta tabla calcula la cantidad de cada producto que hace tu hermandad. Tomamos una medida aproximada del porcentaje de cada miembro y, por defecto, asumimos que cada miembro 
                hace 3 recolecciones por día
                    (2x9h y 1x3h). Para mejorar la precisión, pregunta a los miembros de tu hermandad cuáles son sus valores reales e introdúcelos a continuación. Puedes guardar lo que introduces
para que aparezca la próxima vez que cargues esta página. Los gráficos de barras anteriores se actualizarán automáticamente después de realizar cambios. Coloca el cursor sobre
la columna del encabezado para obtener más información sobre una columna en particular."
    `,
                refreshButtonText: 'Refrescar el listado de miembros',
                refreshButtonTip: 'Esto añadirá nuevos miembros, eliminará antiguos, actualizará los roles de la hermandad y su puntuación actual',
                inactiveWarningTip: 'Puede que el usuario esté inactivo, puntuación actualizada por última vez: {0}',
                collectsPerDayValidation: "Debe ser entre 1-6",
                boostPercentValidation: "Debe ser entre 40 - 700, no incluyas la bonificación de la caverna de la montaña",
                perDayShort: "/día",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "La puntuación del jugador, por favor ten en cuenta que no se actualiza en tiempo real. Se actualiza varias veces por semana.",
                chapterTip: "Este es el capítulo el cual se encuentra cada jugador. Para tomar como referencia: Elementales = 12, Medianos = 11 etc.",
                boostTip: "La bonificación del jugador y la cantidad PRODUCIDA por día.",
                collectsPerDayTip: `***EDITABLE*** <br/>Recolecciones por día. Este es el número de veces que un usuario recolecta al día a sus fábricas. Debería ser un valor entre 1-6. 1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Mira el FAQ para más información.`,
    relicBoostPercentTip: `***EDITABLE***<br/>El porcentaje de bonificación de las reliquias, entre 40-700. No debería incluir el porcentaje de la Caverna de la Montaña. Se detecta automáticamente y se añade a este número`,
                mountainHallPercentTip: "Este es el Porcentaje de bonificación que detectamos a la Caverna de la Montaña para este usuario. Se usa junto con el % de bonificación para calcular el % total.",
                updatedTip: "Este es el tiempo desde la última vez que la ciudad del jugador fué analizada. Este proceso es el que selecciona las bonificaciones, datos de Elven Achitect, cálculo de la producción de todas las fábricas, el % de la Caverna y mucho más. Los datos de la ciudad se actualizan periodicamente, pero puedes forzar una actualización manual haciendo click en el botón de actualizar",

            },
            coinsAndSuppliesTable: {
                heading: "Producción de Monedas/Provisiones",
                description: `La columna principal es "Provisiones restantes" ya que indica si un miembro producirá suficientes provisiones para mantener sus fábricas que producen 24/7. Usa los interruptores de palanca a continuación para tener en cuenta la bonificación cultural mínima de los jugadores (que es la bonificación que tendrías si no tuvieras ayuda vecinal) y/o la cantidad de veces que el jugador recolecta por día (como se especifica en la Tabla de Productos más arriba). Desactivar ambos es útil si deseas ver cuánto de las provisiones se le atribuyen a más fábricas o una mayor bonificación cultural. Finalmente, ten en cuenta que tener un número negativo  bajo (~ 10% del total) de  provisiones restantes es bastante común. Hay muchas formas en que los jugadores
complementan sus provisiones, por ejemplo visitando vecinos, produciendo provisiones a intervalos más rápidos (Bebidas, Herramientas simples, Pan ...) o usando hechizos de Poder de las provisiones. Piensa en el valor negativo como lo que tendrías que compensar a diario al hacer una de estas opciones.
NOTA: en este momento, la producción de las tropa no se tiene en cuenta en las provisiones utilizadas (solo productos de nivel 1, nivel 2 y nivel 3), por lo que es posible que necesites más.`,
                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Bonif. Min %",
                made: "Hechas",
                used: "Usadas",
                left: "Restante",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "El porcentaje de bonificación cultural. IMPORTANTE: este valor se calcula asumiendo que no hay AYUDA VECINAL en los edificios culturales. En la realidad, este % será mayor en tu ciudad.",
                moneyComputedTip: "La cantidad de monedas producidas en un día, incluyendo las Maravillas Antiguas que produzcan monedas.",
                moneyUsedComputedTip: "La cantidad de monedas consumidas al producir provisiones.",
                moneyRemainingComputedTip: "Monedas - Monedas utilizadas, este es el superhávit o déficit de monedas que un jugador tendrá cada día.",
                suppliesComputedTip: "El número de provisiones que se producirían si todos los talleres se colocasen en 24x1 (Caja de Herramientas) +  cualquier maravilla antigua. (No incluye bonificaciones Set)",
                suppliesUsedComputedTip: "El número de provisiones consumidas al producir productos. NO incluye provisiones usadas en los cuarteles! Ver la explicación más arriba.",
                suppliesRemainingComputedTip: "Provisiones - Provisiones utilizadas, es el superhávit o déficit de provisiones que tendrá un jugador cada día",
                manaTip: "La cantidad de Maná producido durante 24 horas (no incluye la Abadía del Dragón)",
            },
            popCultureTable: {
                heading: "Población/Detalle de Cultura",
                description: 'La tabla muestra la población / cultura de cada miembro. Pasa el ratón por encima de cada encabezado para más información',

                // Icon Sub-Headings
                minBoostPercent: "%de Bonif. Mín",
                levels: "Niveles",
                total: "Total",
                working: "Trabajando",
                available: "Disponible",
                required: "Requerido",

                // Low Priority - Tool Tips
                wonderLevelsTip: "El número de niveles totales de Maravillas Antiguas que tiene un jugador.",
                cultureBoostPercentTip: "El porcentaje de bonificación cultural. IMPORTANTE: este valor se calcula asumiendo que no hay AYUDA VECINAL en los edificios culturales. En la realidad, este % será mayor en tu ciudad.",
                totalPopulationTip: "La población total producida por viviendas, edificios de cultura/población y Maravillas antiguas",
                workingPopulationTip: "Población Ocupada - La cantidad consumida por edificios",
                availablePopulationTip: "Población Disponible",
                totalCultureTip: "La cultura total producida por edificios culturales, edificios de cultura/población y Maravillas antiguas",
                requiredCultureTip: "Cultura requerida para todos tus edificios",
                availableCultureTip: "Cultura Disponible",
            },
            cityCoverageTable: {
                heading: "Expansión de la Ciudad",
                description: "Miestra cuantas cuadrículas están siendo usadas en cada ciudad para cada edificio. Las cuadrículas vacías son las que actualmente no están siendo usadas",
                tiles: 'Cuadrícula'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "",
                description: "Generamos automáticamente informes semanales que pueden ser compartidos con tu hermandad. Un nuevo informe estará disponible cada domingo (alrededor de las 20h UTC) para la semana anterior. Simplemente copia la dirección siguiente y pégalo donde quieras!",
                selectReportHint: "Selecciona Informe para la semana que finaliza el",
                reportsAreOptimizedFor: "Los emails de los informes están optimizados para mostrar de la forma más óptima posible en el sistema de mensagería de Elvenar, tales como alineación etc",
                accolades: "Premios",
                tourneyChamp: " - Campeón del Torneo (esta semana): {0}",
                tourneyHero: " - Héroe del Torneo (últimas 4 semanas): {0}",
                highestGrowthPlusPercentage: " - Mayor crecimiento (puntos & porcentajes): {0}",
                highestGrowthPoints: " - Mayor crecimiento (puntos): {0}",
                highestGrowthPercentage: " - Mayor crecimiento (porcentaje): {0}",
                highestGrowthError: " - Mayor crecimiento: no se puede determinar, se requiere más información histórica",
                newPersonalRecords: "Nuevo récord personal",
                userSetANewPersonalRecordFor: " * {0} selecciona un nuevo récord personal para: {1}",
                allMembersByPointGainThisWeek: "TODOS LOS MIEMBROS por puntos ganados / porcentaje (esta semana)",
                tournamentPointsHeader: "Puntos de TORNEO (esta semana / TOTAL DESDE {0})",
                top8ByPercentage: "TOP 8 por Porcentaje (esta semana)",
                top8ByPointsSince: "TOP 8 por Puntos (desde {0})",
                top8ByPercentageSince: "TOP 8 por Porcentaje (Since {0})",
                reportGeneratedBy: "Informe generado por elvenstats.com, para más ver: ",
                mostPointsInAWeek: "Más puntos en una semana",
                highestTournamentScore: "Puntuación mayor en Torneo",
                highestTournamentRank: "Rango de Clasificación más alta ",
                insufficientHistoryForThesePlayers: "* Omitido: {0} debido a no disponer de más datos. Se incluirá la próxima semana",
                insufficientHistory1Week: "* Datos históricos insuficientes. Revisa la próxima semana!",
                insufficientHistory4Weeks: "* Datos históricos insuficientes. Se necesitan datos de las últimas 4 semanas. Revisa la próxima semana!",
            },
            memberHistory: {
                heading: "Historial del miembro",
                noChangesDetected: "No se han detectado cambios desde que empezó el seguiento el {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Tienes cambios sin guardad. Cuando acabes de editar tu hermandad haz click en el botón de guardar.',
                standbyImporting: 'Por favor espera: Estamos importando datos que faltaban a alguno de tus hermanos',
                limitedHistory: "Hemos empezado a seguir recientemente este {0}  por lo que hay historial limitado. Cada domingo, snapshots semanales se mostrarán aquí, por lo que no dudes en volver pronto",
                noChangesSinceTrackingBegan: "Sin cambios desde que empezó el seguimiento",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Historial de la Hermandad"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Actualizaciones en tiempo real no están disponibles de momento.",
            realTimeUpdatesNotAvailableDescription: "Esto puede ocurrir debido a que los Servidores de Elvenar han sido reiniciados para lanzar una actualización o por mantenimiento. Cuando esto ocurre, ElvenStats debe ingresar manualmente a todos los servidores antes de poder dar la información a demanda. Por favor inténtalo de nuevo en un par de horas. Mientras tanto toda la página está operativa al 100%.",
            copyToClipboardSuccessful: "Se ha copiado al portapapeles con éxito.",
            copyToClipboardFailed: "Fallo al copiar, selecciona toda el texto y después haz CTRL+C.",
            errorOccurredImporting: "Se ha producido un error. Importando tus usuarios.",
            errorOccurredImportingMessage: "Ha ocurrido un error mientras intentábamos importar tus usuarios. Por favor inténtalo de nuevo. Si persiste el error, contacta con nosotros.",
            errorOccurredImportingWillNotBeAvailableInReports: "Los usuarios que no han sido importados no serán incluídos en el informe.",
            finishedSyncSuccessful: "FInalizado, la sincronización ha sido exitosa.",
            playerIsAnonymous: "El jugador ha solicitado que su información no sea mostrada en elvenstats.com",
            inactiveWarningTip: "Puede que este jugador esté inactivo. Puntuación sin cambios desde: {0}",
            isFriendTip: "Este jugador es amigo para ElvenStats. ¡Ha contribuido con su tiempo y/o dinero para dar soporte al sitio!",
        },
    }
}


// WEBPACK FOOTER //
// ./src/lang/es.js